import React, { ChangeEvent, useState } from "react";
import {
  useDiscardTestMutation,
  useGetDiscardInfoOptionsQuery,
  useLazyResumeTestQuery,
} from "../../redux/API/StartTest/startTestApi";
import {
  setStartedTestId,
  StartedTestId,
} from "../../redux/Slices/startFullTestSlice";
import Dropdown from "../../pages/LogInPage/Dropdown";
import { MdArrowBackIosNew } from "react-icons/md";
import AuthButton from "../../pages/LogInPage/LoginButton";
import { useDispatch, useSelector } from "react-redux";
import { closeDialog } from "../../redux/Slices/dialogSlice";
import { RiDeleteBinLine } from "react-icons/ri";
import { RootState } from "../../redux/Store/store";

const DiscardInfo = () => {
  const dispatch = useDispatch();
  const [discardTest] = useDiscardTestMutation();
  const [resumeTest] = useLazyResumeTestQuery();
  const {data:optionData} = useGetDiscardInfoOptionsQuery({});
  const [selectedReason, setSelectedReason] = useState({
    reason: "",
    description: "",
    isTextArea: false
  });
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [submitLoader, setSubmitLoader] = useState(false);
  const { startedTestId } = useSelector(
    (state: RootState) => state.root.startFullTest
  );

  const handleDiscardTest = async () => {
    try {
      if (startedTestId.userTestId) {
        setSubmitLoader(true);
        let payload = {
          userTestId: startedTestId.userTestId,
          reason: selectedReason.reason,
          description: selectedReason.description,
        };
        const response = await discardTest(payload).unwrap();
        if (response.status === "success") {
          const resumeResponse = await resumeTest({});
          if (resumeResponse.isSuccess) {
            let payload = {
              testId: resumeResponse.data?.testId,
              testName: resumeResponse.data?.testname,
              createdDate: resumeResponse.data?.createdDate,
              userTestId : resumeResponse.data?.userTestId ?? '',
              isFirstTest : resumeResponse.data?.isFirstTest ?? false,
              loading: false,
            };
            dispatch(setStartedTestId(payload));
          }
          setSubmitLoader(false);
          dispatch(closeDialog());
        }
      }
    } catch (e) {
      setSubmitLoader(false);
      console.error(e, "Discard Test");
    }
  };
  const handleDropdownChange = (val: any) => {
    if (!val.isTextArea) {
      setSelectedReason({ reason: val.reason, description: "", isTextArea: false });
    } else {
      setSelectedReason((prev) => ({ ...prev, reason: val.reason, isTextArea: val.isTextArea }));
    }
  };
  const handleDescription = (e: ChangeEvent<HTMLTextAreaElement>) => {
    if(e.target.value.length < 200) {
      setSelectedReason((prev) => ({ ...prev, description: e.target.value }));
    }
  };
  const handleCloseDialog = () => {
    dispatch(closeDialog());
  };
  const getDiscardDisabled = () => {
    if (selectedReason.reason === "") {
      return true;
    }

    if (
      selectedReason.reason === "Other reasons" &&
      selectedReason.description.trim() === ""
    ) {
      return true;
    }

    if (submitLoader) {
      return true;
    }
    return false;
  };
  
  return (
    <div className="flex flex-col gap-9 justify-between items-center p-6 pb-9 bg-satPrepFrostedWhite backdrop-blur-[20px] shadow-dialog border-[0.5px] border-satPrepGrey rounded-[28px]">
      <h3 className="text-center font gully text-[40px] font-bold leading-normal font-gully text-satPrepAccent">
        Let us know why you’d like to discard the test
      </h3>
      <div className="flex flex-col items-start gap-6 w-full">
        <div className="flex flex-col justify-center items-start gap-2 w-full">
         
          <div className="w-full px-10">
            <Dropdown
              getOption={(option: any) => `${option.reason}`}
              onChangeHandler={handleDropdownChange}
              setOpen={setDropdownOpen}
              open={dropdownOpen}
              selected={selectedReason.reason}
              options={optionData?.data || []}
              label="Select"
              name="Select"
            />
          </div>
        </div>

        {selectedReason.isTextArea && (
          <div className="flex flex-col gap-2 w-full px-10">
            <div className="flex justify-between items-center w-full">
            <p className="text-black font-gully text-xs font-semibold whitespace-nowrap">
              Specify reason 
            </p>
            <span className="text-black font-gully text-[14px] font-normal whitespace-nowrap">Max 200 characters</span>
            </div>
            <textarea
              className="w-full h-[208px] py-[13px] px-[21px] text-base font-gully font-medium  rounded-md border border-satPrepGrey shadow-sm"
              placeholder="Type here..."
              value={selectedReason.description}
              onChange={handleDescription}
            />
          </div>
        )}
      </div>

      <div className="flex justify-between items-center self-stretch px-10">
        <AuthButton
          text="Back"
          icon={<MdArrowBackIosNew />}
          iconPosition="left"
          onClick={handleCloseDialog}
          loader={false}
          disabled={false}
        />
        <AuthButton
          text="Discard"
          icon={<RiDeleteBinLine />}
          iconPosition="left"
          onClick={handleDiscardTest}
          loader={submitLoader}
          disabled={getDiscardDisabled()}
        />
      </div>
    </div>
  );
};

export default DiscardInfo;
